/* global axios */
import ApiClient from './ApiClient';

class InternalGroupsAPI extends ApiClient {
  constructor() {
    super('internal_groups', { accountScoped: true });
  }

  create({ inboxId, name, participantIds }) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      name,
      participant_ids: participantIds,
    });
  }

  removeMember({ inboxId, conversationId, userId }) {
    return axios.delete(`${this.url}/remove_member`, {
      params: {
        inbox_id: inboxId,
        conversation_id: conversationId,
        user_id: userId,
      },
    });
  }

  addMembers({ inboxId, conversationId, participantIds }) {
    return axios.post(`${this.url}/add_members`, {
      inbox_id: inboxId,
      conversation_id: conversationId,
      participant_ids: participantIds,
    });
  }
}

export default new InternalGroupsAPI();
